import InfoCallout from "@components/common/info/InfoCallout.js";
import { GMapsInput } from "@components/common/inputs/GMapsInput";
import { Controller, useForm } from "react-hook-form";

import { Input } from "../../common/inputs/Input.js";

const AddTeamInformation = ({
  teamName,
  setTeamName,
  setTeamLocation,
  error,
}) => {
  const { control } = useForm();

  return (
    <>
      <div className="flex flex-col space-y-4 w-full dark:text-gray-300">
        <div>
          <label className="dark:text-gray-200 text-base">
            <span className="font-semibold">Team Name</span>

            <Input
              placeholder="e.g. Happy Paws Veterinary Clinic"
              value={teamName}
              onChange={(e) => setTeamName(e.target.value)}
              data-testid="team-name-input"
            />
          </label>
          <InfoCallout>
            This is usually the name of your clinic, but can be any
            other name you want to use to identify your team.
          </InfoCallout>
        </div>
        <div>
          <label className="dark:text-gray-200 text-base">
            <span className="font-semibold">Clinic Address</span>

            <Controller
              control={control}
              name="address"
              render={({ field: { ref, onChange, value } }) => {
                return (
                  <GMapsInput
                    updateBillingAddress={setTeamLocation}
                    inputRef={ref}
                    value={value}
                    onChange={onChange}
                  />
                );
              }}
            />
          </label>
        </div>
      </div>
      {error && (
        <div className="text-red-500 mt-2 text-sm">{error}</div>
      )}
    </>
  );
};

export default AddTeamInformation;
